import { maintenanceStatuses } from '../../../core/maintenance-constants';
import { getMaintenanceStatus } from '../../../helpers/time-helpers';
import type { MaintenanceProps } from '../api';

export const handleMaintenance = (data: MaintenanceProps) => {
  if (data.next_maintenance_at && data.next_maintenance_at !== '') {
    const maintenanceDate = data.next_maintenance_at;
    const maintenanceStatus = getMaintenanceStatus(maintenanceDate);
    if (
      maintenanceStatus === maintenanceStatuses.inFiveMinutes ||
      maintenanceStatus === maintenanceStatuses.inProgress
    ) {
      // if there is scheduled maintenance in 5mins or less, redirect to /maintenance
      if (window.location.pathname !== '/maintenance') {
        window.location.href = '/maintenance';
      }
      return true;
    }
    if (
      maintenanceStatus === maintenanceStatuses.withinHour ||
      maintenanceStatus === maintenanceStatuses.inFifteenMinutes
    ) {
      // if there is scheduled maintenance and if it is in less than 1hour show toast for simulator module

      // set to localStorage next maintenance date
      localStorage.setItem('next_maintenance_at', maintenanceDate);
      return maintenanceDate;
    }
    if (maintenanceStatus === maintenanceStatuses.withinDay) {
      return maintenanceDate;
    }
  }
  return false;
};
